import styled, { css } from 'styled-components';

// Constellation
import { Divider as ConstellationDivider, IconPhotosOutline, token } from '@zillow/constellation';

export const CardContainer = styled.div<{ isHovered: boolean; isStriped: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 168px;

  background-color: ${({ isHovered, isStriped }) =>
    css`
      ${isHovered ? token('colors.blue200') : isStriped ? token('colors.gray100') : token('colors.white')}
    `};
`;

export const CardAddress = styled.div<{ height: number | null }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  word-wrap: break-word;
  text-align: left;
  ${({ height }) => height && `height: ${height}px;`}
`;

export const StatusDot = styled.span<{ isActive: boolean | null }>`
  height: 12px;
  width: 12px;
  background-color: ${({ isActive }) =>
    css`
      ${isActive ? token('colors.forRent') : token('colors.offMarket')}
    `};
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
`;

export const CardThumbnail = styled.img`
  height: 168px;
  width: 168px;
  object-fit: cover;
  align-self: center;
`;

export const CardThumbContainer = styled.div`
  display: flex;
  height: 168px;
  width: 168px;
  background: ${token('colors.gray300')};
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;

export const Fallback = styled(IconPhotosOutline)`
  content: '';
  font-size: 64px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardPriceRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
`;

export const Divider = styled(ConstellationDivider)`
  width: calc(100% + 16px);
`;
